import React, {useState, useEffect} from 'react';
import './Result.css';
import Container from '../../UI/Container/Container';
import Button from '../../UI/Button/Button';
import 'chart.js/auto';
import { Doughnut } from 'react-chartjs-2';
import shipImg from '../../../images/ship.PNG';
import truckImg from '../../../images/truck.png';
import SavingTrees from '../SavingTrees/SavingTrees';


const Result = (props) => {

    let totalEmissionsByRoad = Math.round(Number(props.calculatedCo2Vals.co2ByRoad));
    let totalEmissionsByTSG  =  Math.round(Number(props.calculatedCo2Vals.co2FromShipping) + Number(props.calculatedCo2Vals.co2Sea) + Number(props.calculatedCo2Vals.co2ToShipping));
    console.log(props);
    const [chartState, setChartState] = useState({
        labels: ["Co2 TSG shipping", "Co2 by Road"], 
        datasets:[
            { 
                label:"co2", 
                data: [totalEmissionsByTSG, totalEmissionsByRoad],
                backgroundColor: ["green", "red"]
            }
        ]
    });
    let options = {
        rotation: -90,
        circumference: 180
    }

    //necessary for exporting chart as pdf otherwise background of canvas is black
    const setChartBackground = {
        id: 'custom_canvas_background_for_export',
        beforeDraw: (chart) => {
            const drawCtx = chart.canvas.getContext("2d");
            drawCtx.save();
            drawCtx.globalCompositeOperation = 'destination-over';
            drawCtx.fillStyle = 'rgba(240,240,240,1)';
            drawCtx.fillRect(0,0,chart.width, chart.height);
            drawCtx.restore();
        }
    }

    return(
        <div className="tsg-calculator-results-container">
            <section className="tsg-from-to-timeline">
                <div className="tsg-timeline-container">
                    <span className="tsg-timeline-start">{props.fromDestination.address}</span>
                    <div className="tsg-timeline">
                        <div className="tsg-timeline-circle"></div>
                        <div className="tsg-timeline-line"></div>
                        <div className="tsg-timeline-circle end-circle"></div>
                    </div>
                    <span className="tsg-timeline-end">{props.toDestination.address}</span>
                </div>
            </section>    
            <section id="tsg-results-result-row-id" className="tsg-results-result-row">
                <Container containerId={"tsg-results-result-row-id-2"}>
                    <div className="tsg-by-land__column">
                        <div className="tsg-header">
                            <h3>Road Transport</h3>
                        </div>
                        <table>
                            <thead>
                                <tr>
                                    <th>Route</th>
                                    <th>MOT</th>
                                    <th>KM</th>
                                    <th>C02 (KG)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="">{props.fromDestination.address} - {props.toDestination.address}</td>
                                    <td className="problematic-svg"><img src={truckImg} alt=""/></td>
                                    <td>{Math.round(Number(props.totalDistance[2]) / 1000)}</td>
                                    <td>{Math.round(Number(props.calculatedCo2Vals.co2ByRoad))}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div className="tsg-total-co2-container">
                            <span><strong>Total distance:</strong> {Math.round(Number(props.totalDistance[2]) / 1000)} KM</span>
                            <span><strong>Total emissions:</strong> {Math.round(Number(totalEmissionsByRoad))} KG/CO2</span>
                        </div>
                    </div>
                </Container>
                <Container containerId={"tsg-results-result-row-id-3"}>
                <div className="tsg-by-sea__column">
                    <div className="tsg-header">
                        <h3>TSG Shipping</h3>
                    </div>
                    <table>
                        <thead>
                            <tr>
                                <th>Route</th>
                                <th>MOT</th>
                                <th>KM</th>
                                <th>C02 (KG)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{props.fromDestination.address} - {props.portDistances[0].originalPortLocation}</td>
                                <td className="problematic-svg"><img src={truckImg} alt=""/></td>
                                <td>{Math.round(Number(props.portDistances[0].shortestDistance)/1000)}</td>
                                <td>{Math.round(Number(props.calculatedCo2Vals.co2FromShipping))}</td>
                            </tr>
                            <tr>
                                <td>{props.portDistances[0].originalPortLocation} - {props.portDistances[1].originalPortLocation}</td>
                                <td className="problematic-svg"><img src={shipImg} alt="" /></td>
                                <td>{props.calculatedCo2Vals.seaDistance}</td>
                                <td>{Math.round(Number(props.calculatedCo2Vals.co2Sea))}</td>
                            </tr>
                            <tr>
                                <td>{props.portDistances[1].originalPortLocation} - {props.toDestination.address}</td>
                                <td className="problematic-svg"><img src={truckImg} alt=""/></td>
                                <td>{Math.round(Number(props.portDistances[1].shortestDistance)/1000)}</td>
                                <td>{Math.round(Number(props.calculatedCo2Vals.co2ToShipping))}</td>
                            </tr>
                        </tbody>
                    </table>
                    <div className="tsg-total-co2-container">
                        <span><strong>Total distance:</strong> {Math.round(Number(props.portDistances[0].shortestDistance)/1000 + Number(props.portDistances[1].shortestDistance)/1000 + Number(props.calculatedCo2Vals.seaDistance))} KM</span>
                        <span><strong>Total emissions:</strong> {Math.round(Number(totalEmissionsByTSG))} KG/CO2</span>
                    </div>
                </div>
                </Container>
            </section>
            <section className="tsg-results-chart-container">
                <Container containerId={"asdaada"}>
                    <Doughnut id={"custom_canvas_background_for_export"} data={chartState} options={options} plugins={[setChartBackground]}/> 
                </Container>
            </section>
            <section className="tsg-results-save-trees-container">
                <Container>
                    <SavingTrees co2Road={Math.round(Number(totalEmissionsByRoad))} co2Sea={Math.round(Number(totalEmissionsByTSG))}/>
                </Container>
            </section>
            <section className="tsg-actions">
                <Container containerId={"dasdas"}>    
                    <div className="tsg-actions-buttons">
                        <Button onClickHandler={props.generatePDF}>Generate PDF</Button>
                        <a href={window.location.protocol+"//"+window.location.hostname+"/c02"} className="tsg-button">Contact us</a>
                    </div>
                </Container>
            </section>  
        </div>
    );
}

export default Result;